module.exports = __webpack_public_path__ + "rfm-avatar-default.svg?b2ac295916d66e6379cb8be471326051";